import * as types from './types';

const initialState = {
  COLIdashboardCount: {},
  COLIdashboardlist: {}
};
export default function clientsReducer(state = initialState, action) {
  switch (action.type) {
    case types.COLI_DASHBOARD_COUNT_SUCCESS: {
      return {
        ...state,
        COLIdashboardCount: action.payload
      };
    }
    case types.COLI_DASHBOARD_COUNT_FAILURE:
      return { ...state, error: action.payload };

    case types.COLI_DASHBOARD_LIST_SUCCESS: {
      return {
        ...state,
        COLIdashboardlist: action.payload
      };
    }
    case types.COLI_DASHBOARD_LIST_FAILURE:
      return { ...state, error: action.payload };

    default:
      return state;
  }
}
